import { useEffect, useEffectEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { datadogLogs } from '@datadog/browser-logs';

import { Button } from '@motorway/mw-highway-code';
import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { useFetch, useReport, REPORT_OUTCOMES } from '@motorway/motorway-handshake-components';

import { BackButton } from '../../components/BackButton/BackButton';
import { Header } from '../../components/Header/Header';
import { ReportCard } from '../../components/ReportCard/ReportCard';
import { debouncedAlert } from '../../helpers/debouncedAlert';
import { ROUTES } from '../../helpers/routes';
import { snowplowCtaClick } from '../../helpers/snowplow';

import styles from './SendReport.module.scss';

export const SendReport = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { report } = useReport();
  const { patchReport, submitReport } = useFetch();

  const navigate = useNavigate();

  const sendPatchReport = useEffectEvent(() => {
    patchReport({ reportData: { ...report } });
  });

  useEffect(() => {
    sendPatchReport();
  }, []);

  const { outcome } = report.inspection;
  const IS_ADJUSTMENT = outcome === REPORT_OUTCOMES.ADJUSTMENT;

  const LABEL = 'Send to seller';

  return (
    <>
      <BackButton />
      <div className={styles.component}>
        <Header>
          <h1>Send your inspection report to the seller</h1>
          <p>This report is also shared with Motorway, so we can help if any questions come up.</p>
        </Header>
        <ReportCard className={styles.report} />
        {
          IS_ADJUSTMENT && (
            <InfoBox
              content="Address the price amendment with the seller before submitting the report, as it cannot be changed afterwards."
              variant="info"
            />
          )
        }
        <div className={styles.button}>
          <Button
            fullWidth
            label={LABEL}
            onClick={async () => {
              setIsSubmitting(true);

              const { success } = await submitReport();

              setIsSubmitting(false);

              snowplowCtaClick({
                button_label: LABEL,
                name: 'report_send',
                success,
                url: ROUTES.PENDING,
              });

              if (!success) {
                datadogLogs.logger.error('Report submit failed', { reportData: report });
                debouncedAlert('There was an issue submitting your report. Please try again.');
                return void 0;
              }

              navigate(ROUTES.PENDING, { replace: true });
            }}
            loading={isSubmitting}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </>
  );
};
